import { AccountStatementFilter } from "@api-types/account-settings/AccountStatementFilter";
import { UserPaymentTransactionLimited } from "@api-types/account-settings/UserPaymentTransactionLimited";

import { httpClient } from "@utils";
import { FindResultDto } from "@api-types/FindResultDto";
import { ContextOptions, ApiRequestContextData } from "@utils/api-config/types";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { getApiRequestContext } from "@utils/api-config";
export class AccountStatementApiService {
	static baseUrl(context?: ApiRequestContextData): string {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/account-statements/${context?.userId}`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findAccountStatements(
		filterModel: AccountStatementFilter,
		options: ContextOptions
	): Promise<FindResultDto<UserPaymentTransactionLimited>> {
		const filter = new URLSearchParams();
		// TODO: do this with all filter properties
		if (filterModel.to) {
			filter.append("to", filterModel.to);
		}
		if (filterModel.from) {
			filter.append("from", filterModel.from);
		}
		if (filterModel.transactionTypeIds) {
			filter.append("transactionTypeIds", filterModel.transactionTypeIds);
		}
		if (filterModel.transactionGroupIds) {
			filter.append(
				"transactionGroupIds",
				filterModel.transactionGroupIds
			);
		}
		if (filterModel.currencyIds) {
			filter.append("currencyIds", filterModel.currencyIds);
		}
		if (filterModel.isOnline) {
			filter.append("isOnline", filterModel.isOnline + "");
		}
		if (filterModel.page) {
			filter.append("page", filterModel.page + "");
		}
		if (filterModel.rpp) {
			filter.append("rpp", filterModel.rpp + "");
		}
		if (filterModel.embed) {
			filter.append("embed", filterModel.embed);
		}
		if (filterModel.fields) {
			filter.append("fields", filterModel.fields);
		}
		if (filterModel.bettingAccountTypeIds) {
			filter.append(
				"bettingAccountTypeIds",
				// @ts-expect-error url search params will automatically apply join(",") to array of strings
				filterModel.bettingAccountTypeIds
			);
		}
		const context = getApiRequestContext(options);
		return await httpClient.get(
			`${this.baseUrl(context)}?${filter.toString()}&translate=true`,
			this.getRequestHeaders(context)
		);
	}
}
